import React, { Component } from "react"
import { connect } from "react-redux"
import Dialog from "@material-ui/core/Dialog"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import LoadingButton from "../../components/LoadingButton"
import Button from "@material-ui/core/Button"
// import {
//   toggleAddClientDialog,
//   toggleDeleteClientDialog,
//   deleteClient,
//   _setEditClient,
//   getClientList,
  
// } from "../../actions/clients"
import {
    toggleEditShootDialog,
    toggleDuplicateShootDialog,
    createShoot,
    getShoots,
    createCalendars,
    createMasterCalendar,
    setEditShoot,
    updateShoot,
  } from "../../actions/shoots"
import { openSnackBar } from "../../actions/snack-bar"
import Typography from "@material-ui/core/Typography"
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined"
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined"
import CircularProgress from "@material-ui/core/CircularProgress"

class DuplicateConfirmDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
        working: false
      }
  }

  handleClose = () => {
    this.props.dispatch(toggleDuplicateShootDialog(false))
    this.props.dispatch(toggleEditShootDialog(true))
  }
//   deleteClient = () => {
//     const { client } = this.props
//     this.setState({
//       savingProfile: false,
//     })
//     this.props
//       .dispatch(deleteClient(client.id))
//       .then(res => {
//         this.setState({
//           savingProfile: false,
//         })
//         this.props.dispatch(
//           openSnackBar({
//             message: res.message,
//           })
//         )
//         this.props.dispatch(toggleDeleteClientDialog(false))
//         this.props.dispatch(_setEditClient())
//         this.props.dispatch(getClientList())
//       })
//       .catch(err => {
//         this.setState({
//           savingProfile: false,
//         })
//         this.props.dispatch(
//           openSnackBar({
//             message: "There was an unknown error",
//           })
//         )
//         return
//       })
//   }

  duplicate = () => {
    let shootId
    this.setState({ working: true })
    const shoot = this.props.shoot
    this.setState({ anchorEl: null })
    const newShoot = {
      ...shoot,
      name: "Copy of " + shoot.name,
      start_date: shoot.start_date,
      end_date: shoot.end_date,
      call_time: shoot.call_time,
      full_day: shoot.day === "full" ? 1 : 0,
      location: JSON.stringify(shoot.location),
      firm: shoot.firm,
    }
    if (shoot.roles && shoot.roles.length > 0) {
      newShoot.glueData = {
        roles: shoot.roles.map(x => {
          return {
            role_id: x.role_id,
            client_rate: Number(x.client_rate),
            crew_rate: Number(x.crew_rate),
            user_id: x.user_id,
          }
        }),
      }
    }

    if (shoot.equipment.length > 0) {
      if (newShoot.glueData) {
        newShoot.glueData.equipment = shoot.equipment.map(x => {
          return {
            equipment_id: x.equipment_id,
          }
        })
      } else {
        newShoot.glueData = {
          equipment: shoot.equipment.map(x => {
            return {
              equipment_id: x.equipment_id,
            }
          }),
        }
      }
    }

    this.props
      .dispatch(createShoot(newShoot))
      .then(res => {
        shootId = res.shoots[0].id
        return Promise.all([
          this.props.dispatch(createCalendars(shootId)),
          this.props.dispatch(createMasterCalendar(shootId)),
        ])
      })
      .then(r => {
        this.props.dispatch(
          openSnackBar({
            message: `${newShoot.name} is created and ${r.message}`,
          })
        )
        this.goToShootDetails(shootId)
        this.setState({ working: false })
        // window.location.href = "/shoots/" + res.shoots[0].id
      })
      .catch(error => {
        this.props.dispatch(
          openSnackBar({
            message: "Something is wrong, shoot cannot be duplicated",
          })
        )
        this.setState({ working: false })
      })
  }


  goToShootDetails = async shootId => {
    await this.props.onClickEdit(shootId)
    await this.props.dispatch(setEditShoot())
  }

  render() {
    const { fullScreen, classes, shoot } = this.props
    const { working } = this.state
    return (
      <Dialog
        fullScreen={fullScreen}
        open={this.props.confirmDuplicateShootDialogueOpen}
        onClose={this.handleClose}
        onEntered={this.setUpForm}
        onExited={this.clearState}
        aria-labelledby="responsive-dialog-title"
      >
        <form id="edit-form" noValidate autoComplete="off">
          <DialogTitle
            disableTypography
            style={{
              backgroundColor: "#0049ac",
              color: "white",
            }}
          >
            {/* <DeleteOutlinedIcon
              style={{
                color: "#dc004e",
                cursor: "pointer",
              }}
              onClick={this.deleteClient}
              aria-label="Close"
            /> */}
            <Typography>Duplicate Shoot {shoot.name}</Typography>
          </DialogTitle>
          {working && working == true ? (
            <CircularProgress style={{ margin: "100px" }} />
              ) : (
            <div>
          <DialogContent style={{ padding: "25px" }}>
         
            <Typography variant="h6">
              {"Are you sure you want to duplicate the shoot ?"}
            </Typography>
            <Typography variant="h6">
              {"This action cannot be undone."}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={this.handleClose}>
              Cancel
            </Button>
            <LoadingButton
              style={{ color: "#f1f1f1", backgroundColor: "#0049ac" }}
              buttonclicked={this.duplicate}
              type="button"
            >
              Duplicate
            </LoadingButton>
          </DialogActions>
          </div>
              )}
        </form>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  return {
    editShootDialogOpen: state.shoots.editShootDialogOpen,
    confirmDuplicateShootDialogueOpen: state.shoots.confirmDuplicateShootDialogueOpen,
    shoot: state.shoots.editShoot,
    // deleteClientDialogOpen: state.clients.deleteClientDialogOpen,
    // client: state.clients.editClient,
  }
}
const connector = connect(mapStateToProps)

export default connector(DuplicateConfirmDialog)